import React from 'react';
import { EndpointConfig, SiteConfig } from 'top-context';

interface TopContext {
    appName: string;
    endpointConfig: EndpointConfig;
    siteConfig: SiteConfig;
}

export default React.createContext<TopContext>({} as TopContext);
